import { render, staticRenderFns } from "./estatisticas.vue?vue&type=template&id=476d033c&scoped=true"
import script from "./estatisticas.vue?vue&type=script&lang=js"
export * from "./estatisticas.vue?vue&type=script&lang=js"
import style0 from "./estatisticas.vue?vue&type=style&index=0&id=476d033c&prod&lang=css"
import style1 from "./estatisticas.vue?vue&type=style&index=1&id=476d033c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476d033c",
  null
  
)

export default component.exports